import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { formatDateLong, getLocale } from '../../helpers/dates';
import { SkeletonReservationDetail } from '../Skeletons/SkeletonReservationDetail';
import { useTranslation } from 'react-i18next';
import Money from '../Common/Money/Money';
import style from './timeline.module.css';

const LeadDetail = ({ reservation }) => {
  const { t } = useTranslation();
  const app = useSelector((state) => state.app);
  const [loading, setLoading] = useState(false);
  const locale = getLocale(app.language);

  return (
    <>
      {loading || !reservation ? (
        SkeletonReservationDetail()
      ) : (
        <>
          <div className='order-details fade-up'>
            <div className='pl-2'>
              <div className='font-125 fw-700'>{reservation.showName}</div>
              <div className='text-secondary fw-400'>{reservation.showCitiyNameLong}</div>
              <div className='text-tertiary fw-700 mt-3'>{reservation.customerName}</div>
              <div className='text-tertiary fw-700'>Deal {reservation.referenceCode}</div>
            </div>
            {reservation.pipeline && reservation.pipeline.stages.length > 0 && (
              <div className='mt-4 text-tertiary'>
                <div className={style.timeline}>
                  {reservation.pipeline.stages.map((item, i) => (
                    <div
                      className={`row ${!item.accomplishedAtLocalTime ? 'text-secondary' : ''}`}
                      key={i}
                    >
                      <div className={`col-auto pb-3 text-right ${style.itemLeft}`}>
                        {item.commissionValue > 0 && (
                          <>
                            <img src='../../images/money.png' className={style.money} />
                            <div className='fw-700 font-small'>
                              {item.commissionType == 0 ? (
                                <Money value={item.commissionValue} />
                              ) : item.commissionEarned ? (
                                <Money value={item.commissionEarned} />
                              ) : (
                                item.commissionValue + '% Deal'
                              )}
                            </div>
                          </>
                        )}
                      </div>
                      <div className={`col pb-3 ${style.itemRight}`}>
                        <span
                          className={
                            item.accomplishedAtLocalTime ? style.itemPointComplete : style.itemPoint
                          }
                        ></span>
                        <div className='font-normal fw-700'>{item.label}</div>
                        {i === 0 ? (
                          <div className='mt-4 font-tiny'>
                            {formatDateLong(item.accomplishedAtLocalTime, locale)}
                          </div>
                        ) : (
                          <p className='mt-1 font-tiny'>{item.description}</p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default LeadDetail;
